import Vue from 'vue'

const state = {
  professionalPhotos: null,
  professionalCoverPhoto: null
}

const actions = {
  LOAD_PROFESSIONAL_PHOTOS: ({commit}, queryData) => {
    commit('SET_PROFESSIONAL_PHOTOS', null)
    commit('SET_PROFESSIONAL_COVER_PHOTO', null)
    const url = 'professionals/' + queryData.professional_id + '/photos'
    Vue.http.get(url)
      .then(response => {
        return response.json()
      })
      .then(response => {
        if (!response.error) {
          const photos = response.photos
          const arrPhotos = []
          for (let key in photos) {
            const photo = photos[key]
            if (photo.is_cover_image === 1) {
              commit('SET_PROFESSIONAL_COVER_PHOTO', photo.image_xl)
            }
            arrPhotos.push(photo.image_xl)
          }
          commit('SET_PROFESSIONAL_PHOTOS', arrPhotos)
        }
      })
  }
}

const mutations = {
  'SET_PROFESSIONAL_PHOTOS': (state, photos) => {
    state.professionalPhotos = photos
  },
  'SET_PROFESSIONAL_COVER_PHOTO': (state, photoUrl) => {
    state.professionalCoverPhoto = photoUrl
  }
}

const getters = {
  getState: state => {
    return state
  },
  getProfessionalPhotos: state => {
    return state.professionalPhotos
  },
  getProfessionalCoverPhoto: state => {
    return state.professionalCoverPhoto
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/professional.photos.js